export function matchAnyPath(str: string) {
  return str + '*'
}

type LocationData = Pick<Location, 'pathname' | 'search'>

export const getPrevLocationState = (location: LocationData) => ({
  prevLocation: {
    pathname: location.pathname,
    search: location.search,
  },
})
